/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ColumnResizedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import {
  faTrashCan,
  faMagnifyingGlass,
  faSpinner,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import { DeleteUserModal } from "./components/user-management/DeleteUserModal";
import { AddUserModal } from "./components/user-management/AddUserModal";
import { UserDetailsModal } from "./components/user-management/UserDetailsModal";
import {
  useGetCognitoUsersQuery,
  useLazyGetCognitoUsersQuery,
} from "../../services/serverless";
import { UserInfo } from "../../services/types/gallus";
import { Error } from "../../components/Error";
import { ReactSelectOption } from "../Interfaces";

interface AdminUserManagementProps {
  cognitoGroup: string;
  preferredUsernameIsEmail: boolean;
  availableCognitoGroupsForCreation: ReactSelectOption[];
  disableEdit: boolean;
  disableDelete: boolean;
  rlsIsEnabled: boolean;
}

interface AdminUserList {
  username: string;
  email: string;
  options: string;
  groups: string[];
  preferredUsername?: string;
  family_name?: string;
  given_name?: string;
}

export const AdminUserManagement = (props: AdminUserManagementProps) => {
  const [ssoEnabled, setSSOEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingNewUsers, setLoadingNewUsers] = useState<boolean>(false);
  const [deleteUserModalIsOpen, setDeleteUserModalIsOpen] =
    useState<boolean>(false);
  const [addUserModalIsOpen, setAddUserModalIsOpen] = useState<boolean>(false);
  const [userDetailsModalIsOpen, setUserDetailsModalIsOpen] =
    useState<boolean>(false);
  const [userData, setUserData] = useState<AdminUserList[]>([]);
  const [selectedUser, setSelectedUser] = useState<{
    username: string;
    email: string;
    preferredUsername: string;
  }>();
  const [listUserNextToken, setListUserNextToken] = useState<string | null>(
    null,
  );
  const [cognitoAPIErrorMessage, setCognitoAPIErrorMessage] =
    useState<string>("");

  const getCognitoUsersResult = useGetCognitoUsersQuery({
    cognitoGroup: props.cognitoGroup,
    nextToken: null,
  });

  const toggleAddUserModal = () => {
    setAddUserModalIsOpen(!addUserModalIsOpen);
  };

  const toggleUserDetailsModal = () => {
    setUserDetailsModalIsOpen(!userDetailsModalIsOpen);
  };

  const toggleDeleteUserModal = () => {
    setDeleteUserModalIsOpen(!deleteUserModalIsOpen);
  };

  const [lazyGetCognitoUsersQuery, lazyGetCognitoUsersResults] =
    useLazyGetCognitoUsersQuery();

  const columnDefinitions = [
    { field: "family_name", headerName: "Last Name" },
    { field: "given_name", headerName: "Name" },
    { field: "username", headerName: "Username" },
    { field: "email", headerName: "E-Mail Address" },
    {
      field: "options",
      headerName: "Options",
      cellRenderer: (params: { data: any }) => {
        return (
          <div>
            <button
              className="button-no-background"
              disabled={props.disableEdit}
              onClick={() => {
                if (!ssoEnabled) {
                  setSelectedUser({
                    username: params.data.username,
                    email: params.data.email,
                    preferredUsername: params.data.preferredUsername,
                  });
                  setUserDetailsModalIsOpen(true);
                }
              }}
            >
              <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} />
            </button>
            {!ssoEnabled && (
              <button
                className="button-no-background"
                disabled={props.disableDelete}
                onClick={() => {
                  if (!ssoEnabled) {
                    setSelectedUser({
                      username: params.data.username,
                      email: params.data.email,
                      preferredUsername: params.data.preferredUsername,
                    });
                    setDeleteUserModalIsOpen(true);
                  }
                }}
              >
                <FontAwesomeIcon className="me-2" icon={faTrashCan} />
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const generateUserRowData = (users: UserInfo[]) => {
    var usersArray = users.map((user) => {
      return {
        username: user.username,
        email: user.email ?? "N/A",
        options: user.username,
        groups: user.groups ?? [],
        preferredUsername: user.preferredUsername ?? "N/A",
        family_name: user.family_name ?? "N/A",
        given_name: user.given_name ?? "N/A",
      };
    });

    usersArray.sort((a, b) => (a.family_name < b.family_name ? -1 : 1));

    return usersArray;
  };

  useEffect(() => {
    if (
      getCognitoUsersResult.isSuccess &&
      getCognitoUsersResult.status === "fulfilled"
    ) {
      if (getCognitoUsersResult.data) {
        setListUserNextToken(getCognitoUsersResult.data.nextToken ?? null);
        setUserData(generateUserRowData(getCognitoUsersResult.data.userList));
      } else {
        setCognitoAPIErrorMessage("Userpool List Error");
      }
      setLoading(false);
    }
  }, [getCognitoUsersResult]);

  useEffect(() => {
    if (
      lazyGetCognitoUsersResults.isSuccess &&
      lazyGetCognitoUsersResults.status === "fulfilled"
    ) {
      setListUserNextToken(lazyGetCognitoUsersResults.data.nextToken ?? null);
      setUserData([
        ...userData,
        ...generateUserRowData(lazyGetCognitoUsersResults.data.userList),
      ]);
      setLoadingNewUsers(false);
    }
  }, [lazyGetCognitoUsersResults]);

  /*   useEffect(() => {
    setSSOEnabled(false); //check for SSO integration here
  }, []); */

  function onGridReady(params: ColumnResizedEvent) {
    params.api.sizeColumnsToFit();
  }

  return (
    <div className="container roundedCorners">
      <div className="mb-2">
        <div
          className="col-12 module-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          User Management
          {!ssoEnabled && (
            <div>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
                onClick={() => setAddUserModalIsOpen(true)}
              >
                Add User
              </button>
            </div>
          )}
        </div>
      </div>
      {loading && (
        <div className="loading-div">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!loading && cognitoAPIErrorMessage.length !== 0 && (
        <Error code="501" type="Internal" message={cognitoAPIErrorMessage} />
      )}
      {!loading && cognitoAPIErrorMessage.length === 0 && (
        <div>
          {ssoEnabled && (
            <div className="error-message">
              External userpool detected. View-only mode will be enforced. For
              user creation/deletion, please contact your IT team.
            </div>
          )}
          <div>
            <div>
              <AgGridReact
                domLayout={"autoHeight"}
                defaultColDef={{
                  cellClass: "grid-generic-text",
                  headerClass: "grid-generic-column",
                }}
                onGridReady={onGridReady}
                rowData={userData}
                columnDefs={columnDefinitions}
              />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "right",
                  paddingTop: "10px",
                }}
              >
                {loadingNewUsers && (
                  <div className="loading-div">
                    <FontAwesomeIcon
                      icon={faSpinner}
                      size="2x"
                      spin={true}
                      style={{ margin: "0 auto" }}
                    />
                  </div>
                )}
                <button
                  className="button-no-background"
                  disabled={listUserNextToken === null}
                  onClick={() => {
                    setLoadingNewUsers(true);
                    lazyGetCognitoUsersQuery({
                      cognitoGroup: props.cognitoGroup,
                      nextToken: listUserNextToken,
                    });
                  }}
                >
                  <FontAwesomeIcon className="me-2" icon={faArrowRight} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <DeleteUserModal
        modalIsOpen={deleteUserModalIsOpen}
        selectedUser={selectedUser}
        defaultCognitoGroup={props.cognitoGroup}
        preferredUsernameIsEmail={props.preferredUsernameIsEmail}
        toggleModal={toggleDeleteUserModal}
      />
      <UserDetailsModal
        modalIsOpen={userDetailsModalIsOpen}
        selectedUserUsername={selectedUser?.username}
        selectedUserEmail={selectedUser?.email}
        preferredUsernameIsEmail={props.preferredUsernameIsEmail}
        defaultCognitoGroup={props.cognitoGroup}
        toggleModal={toggleUserDetailsModal}
        rlsIsEnabled={props.rlsIsEnabled}
      />
      <AddUserModal
        defaultCognitoGroup={props.cognitoGroup}
        availableCognitoGroups={props.availableCognitoGroupsForCreation}
        preferredUsernameIsEmail={props.preferredUsernameIsEmail}
        modalIsOpen={addUserModalIsOpen}
        toggleModal={toggleAddUserModal}
      />
    </div>
  );
};
